import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = {
  key: 0,
  class: "title mb-0"
}
const _hoisted_7 = {
  key: 1,
  class: "title mb-0"
}
const _hoisted_8 = {
  key: 2,
  class: "title mb-0"
}
const _hoisted_9 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_10 = { "aria-label": "breadcrumb" }
const _hoisted_11 = { class: "breadcrumb mb-0" }
const _hoisted_12 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_13 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_14 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "text-md-right" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { for: "" }
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { for: "" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-2" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { for: "" }
const _hoisted_30 = { class: "dropdown-wrap unit-dropdown position-relative" }
const _hoisted_31 = { class: "mr-3" }
const _hoisted_32 = { class: "dropdown-actions" }
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { for: "" }
const _hoisted_38 = { class: "d-flex" }
const _hoisted_39 = { class: "control-wrap" }
const _hoisted_40 = { class: "col-md-2" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { for: "" }
const _hoisted_43 = { class: "d-flex" }
const _hoisted_44 = { class: "control-wrap" }
const _hoisted_45 = {
  key: 0,
  class: "dropdown-wrap position-relative"
}
const _hoisted_46 = {
  class: "btn-sm bg-light h-100 rounded-0",
  type: "button",
  "aria-expanded": "false"
}
const _hoisted_47 = { class: "mr-3" }
const _hoisted_48 = {
  key: 1,
  class: "dropdown-wrap position-relative"
}
const _hoisted_49 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_50 = { class: "mr-3" }
const _hoisted_51 = { class: "col-md-2" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { for: "" }
const _hoisted_54 = { class: "d-flex" }
const _hoisted_55 = { class: "control-wrap" }
const _hoisted_56 = {
  key: 0,
  class: "form-group"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_59 = {
  key: 1,
  class: "table-responsive my-3 font-12"
}
const _hoisted_60 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_61 = { class: "table-primary nowrap-text" }
const _hoisted_62 = { scope: "col" }
const _hoisted_63 = { scope: "col" }
const _hoisted_64 = { scope: "col" }
const _hoisted_65 = { scope: "col" }
const _hoisted_66 = { scope: "col" }
const _hoisted_67 = { scope: "col" }
const _hoisted_68 = {
  key: 0,
  scope: "col"
}
const _hoisted_69 = { class: "table-input-checked-wrap" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  key: 1,
  class: "dropdown-wrap unit-dropdown position-relative"
}
const _hoisted_72 = { class: "mr-3" }
const _hoisted_73 = { class: "dropdown-actions" }
const _hoisted_74 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_76 = { class: "d-flex" }
const _hoisted_77 = { class: "control-wrap" }
const _hoisted_78 = { class: "d-flex" }
const _hoisted_79 = { class: "control-wrap" }
const _hoisted_80 = {
  key: 0,
  class: "dropdown-wrap position-relative"
}
const _hoisted_81 = {
  class: "btn-sm bg-light h-100 rounded-0",
  type: "button",
  "aria-expanded": "false"
}
const _hoisted_82 = { class: "mr-3" }
const _hoisted_83 = {
  key: 1,
  class: "dropdown-wrap position-relative"
}
const _hoisted_84 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_85 = { class: "mr-3" }
const _hoisted_86 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_90 = {
  key: 2,
  class: "form-group"
}
const _hoisted_91 = {
  key: 3,
  class: "form-group"
}
const _hoisted_92 = { class: "modal-wrap default-modal" }
const _hoisted_93 = {
  class: "modal fade",
  id: "addUnite",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_95 = { class: "modal-content" }
const _hoisted_96 = { class: "modal-header" }
const _hoisted_97 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_98 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_99 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_100 = { class: "modal-body" }
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = { for: "" }
const _hoisted_103 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_104 = { class: "form-group" }
const _hoisted_105 = /*#__PURE__*/_createVNode("label", { for: "" }, "Abbreviation", -1)
const _hoisted_106 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_107 = { class: "modal-footer" }
const _hoisted_108 = { class: "modal-wrap default-modal" }
const _hoisted_109 = {
  class: "modal fade",
  id: "removeSubItem",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_110 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_111 = { class: "modal-content" }
const _hoisted_112 = { class: "modal-header" }
const _hoisted_113 = {
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_114 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_115 = { class: "modal-body" }
const _hoisted_116 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_117 = { class: "modal-footer" }
const _hoisted_118 = { class: "modal-wrap default-modal" }
const _hoisted_119 = {
  class: "modal fade",
  id: "deleteItem",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_120 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_121 = { class: "modal-content" }
const _hoisted_122 = { class: "modal-header" }
const _hoisted_123 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_124 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_125 = { class: "modal-body" }
const _hoisted_126 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_127 = { class: "text-danger" }
const _hoisted_128 = { class: "modal-footer" }
const _hoisted_129 = { class: "modal-wrap default-modal" }
const _hoisted_130 = {
  class: "modal fade",
  id: "deleteSubItem",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_131 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_132 = { class: "modal-content" }
const _hoisted_133 = { class: "modal-header" }
const _hoisted_134 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_135 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_136 = { class: "modal-body" }
const _hoisted_137 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_138 = { class: "text-danger" }
const _hoisted_139 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_PriceInputField = _resolveComponent("PriceInputField")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isPostLoading.createLineItem || _ctx.state.ui.isPostLoading.updateEstimation)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_ctx.state.ui.isLoading.isEdit)
            ? (_openBlock(), _createBlock("h1", _hoisted_6, _toDisplayString(_ctx.$t('edit_items')), 1))
            : (_ctx.state.ui.isLoading.isShow)
              ? (_openBlock(), _createBlock("h1", _hoisted_7, _toDisplayString(_ctx.$t('show_items')), 1))
              : (_openBlock(), _createBlock("h1", _hoisted_8, _toDisplayString(_ctx.$t('create_items')), 1)),
          _createVNode("div", _hoisted_9, [
            _createVNode("nav", _hoisted_10, [
              _createVNode("ol", _hoisted_11, [
                _hoisted_12,
                _createVNode("li", _hoisted_13, [
                  _createVNode("a", _hoisted_14, _toDisplayString(_ctx.$t('create_line_items')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            (_ctx.state.ui.isLoading.isShow)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block mr-1",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteItemShow && _ctx.deleteItemShow(...args)))
                }, [
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.ui.isLoading.isShow)
              ? (_openBlock(), _createBlock("a", {
                  key: 1,
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block mr-1",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editItem && _ctx.editItem(...args)))
                }, [
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.gotoItemList && _ctx.gotoItemList(...args)))
            }, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.errors.errorList.createLineItem,
        hasError: _ctx.state.ui.errors.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_21, [
        _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('main_title')), 1),
        _withDirectives(_createVNode("input", {
          type: "text",
          class: _ctx.state.ui.errors.validationErrorList.itemName ? 'form-control error-field' : 'form-control',
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.itemName = $event)),
          disabled: _ctx.state.ui.isLoading.isShow
        }, null, 10, ["disabled"]), [
          [_vModelText, _ctx.state.data.itemName]
        ]),
        (_ctx.state.ui.errors.validationErrorList.itemName)
          ? (_openBlock(), _createBlock("p", _hoisted_23, _toDisplayString(_ctx.state.ui.errors.validationErrorList.itemName), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_24, [
        _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('description')), 1),
        _withDirectives(_createVNode("textarea", {
          class: "form-control",
          rows: 5,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.itemDetails = $event)),
          disabled: _ctx.state.ui.isLoading.isShow
        }, null, 8, ["disabled"]), [
          [_vModelText, _ctx.state.data.itemDetails]
        ])
      ]),
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('unit')), 1),
            _createVNode("div", _hoisted_30, [
              _createVNode("a", {
                class: _ctx.state.ui.errors.validationErrorList.itemUnitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                type: "button",
                "data-toggle": "dropdown",
                "aria-expanded": "false",
                disabled: _ctx.state.ui.isLoading.isShow
              }, [
                _createVNode("span", _hoisted_31, _toDisplayString(_ctx.state.data.selectedUnit.name ?
                    _ctx.state.data.selectedUnit.name : _ctx.$t('select_unit')), 1)
              ], 10, ["disabled"]),
              _createVNode("div", {
                class: "dropdown-menu custom-scroll table-dropdown",
                disabled: _ctx.state.ui.isLoading.isShow
              }, [
                _createVNode("a", {
                  class: "dropdown-item border-bottom text-success",
                  href: "javascript:void(0)",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addNewUnit(null)))
                }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                  return (_openBlock(), _createBlock("a", {
                    class: "dropdown-item with-actions",
                    href: "javascript:void(0)",
                    key: unitIndex
                  }, [
                    _createVNode("span", {
                      class: "unit-title d-block",
                      onClick: ($event: any) => (_ctx.selectUnit(unit))
                    }, _toDisplayString(unit.name), 9, ["onClick"]),
                    _createVNode("span", _hoisted_32, [
                      _createVNode("span", {
                        class: "actions-text",
                        onClick: ($event: any) => (_ctx.editUnit(unit))
                      }, [
                        _hoisted_33
                      ], 8, ["onClick"]),
                      _createVNode("span", {
                        class: "actions-text ml-2",
                        onClick: ($event: any) => (_ctx.deleteUnit(null, unit))
                      }, [
                        _hoisted_34
                      ], 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ], 8, ["disabled"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('cost')), 1),
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, [
                _createVNode(_component_PriceInputField, {
                  parentClass: _ctx.state.ui.errors.validationErrorList.itemCostError ? 'form-control error-field' : 'form-control',
                  price: _ctx.state.data.itemCost,
                  onUpdateItem: _ctx.setCost,
                  onKeyup: _ctx.calculateiItemTotal
                }, null, 8, ["parentClass", "price", "onUpdateItem", "onKeyup"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_40, [
          _createVNode("div", _hoisted_41, [
            _createVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('markup')), 1),
            _createVNode("div", _hoisted_43, [
              _createVNode("div", _hoisted_44, [
                (_ctx.state.data.itemMarkupType == 0)
                  ? (_openBlock(), _createBlock(_component_PriceInputField, {
                      key: 0,
                      parentClass: 'form-control',
                      price: _ctx.state.data.itemMarkup,
                      onUpdateItem: _ctx.setMarkup,
                      onKeyup: _ctx.calculateiItemTotal
                    }, null, 8, ["price", "onUpdateItem", "onKeyup"]))
                  : _createCommentVNode("", true),
                (_ctx.state.data.itemMarkupType == 1)
                  ? (_openBlock(), _createBlock(_component_PriceInputField, {
                      key: 1,
                      parentClass: 'form-control',
                      price: _ctx.state.data.itemMarkup,
                      from: _ctx.state.data.inputFrom,
                      onUpdateItem: _ctx.setMarkup,
                      onKeyup: _ctx.calculateiItemTotal
                    }, null, 8, ["price", "from", "onUpdateItem", "onKeyup"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.state.ui.isLoading.isShow)
                ? (_openBlock(), _createBlock("div", _hoisted_45, [
                    _createVNode("a", _hoisted_46, [
                      _createVNode("span", _hoisted_47, _toDisplayString(_ctx.state.data.itemMarkupType == 0 ? '$' : '%'), 1)
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_48, [
                    _createVNode("a", _hoisted_49, [
                      _createVNode("span", _hoisted_50, _toDisplayString(_ctx.state.data.itemMarkupType == 0 ? '$' : '%'), 1)
                    ]),
                    _createVNode("div", {
                      class: "dropdown-menu with-badge-list",
                      disabled: _ctx.state.ui.isLoading.isShow
                    }, [
                      _createVNode("ul", null, [
                        _createVNode("li", null, [
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeItemMarkupType(0)))
                          }, "$ "),
                          (_ctx.state.defMarkUpType != 0)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                class: "badge badge-success",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateMarkupType(0)))
                              }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("li", null, [
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeItemMarkupType(1)))
                          }, "%"),
                          (_ctx.state.defMarkUpType != 1)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                class: "badge badge-success",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateMarkupType(1)))
                              }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 8, ["disabled"])
                  ]))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_51, [
          _createVNode("div", _hoisted_52, [
            _createVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('total')), 1),
            _createVNode("div", _hoisted_54, [
              _createVNode("div", _hoisted_55, _toDisplayString(_ctx.state.data.itemTotal), 1)
            ])
          ])
        ])
      ]),
      ((!_ctx.state.ui.isLoading.isShow && !_ctx.state.ui.isLoading.isEdit) || (_ctx.state.ui.isLoading.isEdit && _ctx.state.data.subItems.length == 0))
        ? (_openBlock(), _createBlock("div", _hoisted_56, [
            (_ctx.state.ui.isLoading.enableSubItem && _ctx.state.data.subItems.length > 0)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn delete-btn",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showRemoveSubItem()))
                }, [
                  _hoisted_57,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('delete_all_subitem')), 1)
                ]))
              : (_openBlock(), _createBlock("button", {
                  key: 1,
                  class: "btn default-btn d-inline-block",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addSubItem()))
                }, [
                  _hoisted_58,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add_subitem')), 1)
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.ui.isLoading.enableSubItem && _ctx.state.data.subItems.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_59, [
            _createVNode("table", _hoisted_60, [
              _createVNode("thead", _hoisted_61, [
                _createVNode("tr", null, [
                  _createVNode("th", _hoisted_62, _toDisplayString(_ctx.$t('name')), 1),
                  _createVNode("th", _hoisted_63, _toDisplayString(_ctx.$t('description')), 1),
                  _createVNode("th", _hoisted_64, _toDisplayString(_ctx.$t('unit')), 1),
                  _createVNode("th", _hoisted_65, _toDisplayString(_ctx.$t('cost')), 1),
                  _createVNode("th", _hoisted_66, _toDisplayString(_ctx.$t('markup')), 1),
                  _createVNode("th", _hoisted_67, _toDisplayString(_ctx.$t('total')), 1),
                  (!_ctx.state.ui.isLoading.isShow)
                    ? (_openBlock(), _createBlock("th", _hoisted_68, _toDisplayString(_ctx.$t('action')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.subItems, (item, itemIndex) => {
                  return (_openBlock(), _createBlock("tr", {
                    class: "",
                    key: itemIndex
                  }, [
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_69, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          id: "sub_input_file",
                          class: item.nameError ? 'form-control error-field' : 'form-control',
                          fdprocessedid: "rfchs",
                          "onUpdate:modelValue": ($event: any) => (item.name = $event),
                          disabled: _ctx.state.ui.isLoading.isShow
                        }, null, 10, ["onUpdate:modelValue", "disabled"]), [
                          [_vModelText, item.name]
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("textarea", {
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (item.description = $event),
                        disabled: _ctx.state.ui.isLoading.isShow,
                        rows: 4,
                        cols: 20
                      }, null, 8, ["onUpdate:modelValue", "disabled"]), [
                        [_vModelText, item.description]
                      ])
                    ]),
                    _createVNode("td", null, [
                      (_ctx.state.ui.isLoading.isShow)
                        ? (_openBlock(), _createBlock("span", _hoisted_70, _toDisplayString(item.selectUnit.name), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_71, [
                            _createVNode("a", {
                              class: item.unitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false",
                              disabled: _ctx.state.ui.isLoading.isShow
                            }, [
                              _createVNode("span", _hoisted_72, _toDisplayString(item.selectUnit ?
                        item.selectUnit.name : 'Select Unit'), 1)
                            ], 10, ["disabled"]),
                            _createVNode("div", {
                              class: "dropdown-menu custom-scroll table-dropdown",
                              disabled: _ctx.state.ui.isLoading.isShow
                            }, [
                              _createVNode("a", {
                                class: "dropdown-item border-bottom text-success",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.addNewUnit(item))
                              }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 9, ["onClick"]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                                return (_openBlock(), _createBlock("a", {
                                  class: "dropdown-item with-actions",
                                  href: "javascript:void(0)",
                                  key: unitIndex
                                }, [
                                  _createVNode("span", {
                                    class: "unit-title d-block",
                                    onClick: ($event: any) => (_ctx.changeUnit(itemIndex, unit))
                                  }, _toDisplayString(unit.name), 9, ["onClick"]),
                                  _createVNode("span", _hoisted_73, [
                                    _createVNode("span", {
                                      class: "actions-text",
                                      onClick: ($event: any) => (_ctx.editUnit(unit))
                                    }, [
                                      _hoisted_74
                                    ], 8, ["onClick"]),
                                    _createVNode("span", {
                                      class: "actions-text ml-2",
                                      onClick: ($event: any) => (_ctx.deleteUnit(item, unit))
                                    }, [
                                      _hoisted_75
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ], 8, ["disabled"])
                          ]))
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_76, [
                        _createVNode("div", _hoisted_77, [
                          _createVNode(_component_PriceInputField, {
                            parentClass: item.costError ? 'form-control error-field' : 'form-control',
                            price: item.cost,
                            onUpdateItem: ($event: any) => (_ctx.updateItem(itemIndex, $event)),
                            onKeyup: ($event: any) => (_ctx.calculateTotal(item))
                          }, null, 8, ["parentClass", "price", "onUpdateItem", "onKeyup"])
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_78, [
                        _createVNode("div", _hoisted_79, [
                          (item.markup_type == 0)
                            ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                key: 0,
                                parentClass: 'form-control',
                                price: item.markup,
                                onUpdateItem: ($event: any) => (_ctx.updateItemMarkup(itemIndex, $event)),
                                onKeyup: ($event: any) => (_ctx.calculateTotal(item))
                              }, null, 8, ["price", "onUpdateItem", "onKeyup"]))
                            : _createCommentVNode("", true),
                          (item.markup_type == 1)
                            ? (_openBlock(), _createBlock(_component_PriceInputField, {
                                key: 1,
                                parentClass: 'form-control',
                                price: item.markup,
                                from: _ctx.state.data.inputFrom,
                                onUpdateItem: ($event: any) => (_ctx.updateItemMarkup(itemIndex, $event)),
                                onKeyup: ($event: any) => (_ctx.calculateTotal(item))
                              }, null, 8, ["price", "from", "onUpdateItem", "onKeyup"]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.state.ui.isLoading.isShow)
                          ? (_openBlock(), _createBlock("div", _hoisted_80, [
                              _createVNode("a", _hoisted_81, [
                                _createVNode("span", _hoisted_82, _toDisplayString(item.markup_type ==
                      0 ? '$' : '%'), 1)
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_83, [
                              _createVNode("a", _hoisted_84, [
                                _createVNode("span", _hoisted_85, _toDisplayString(item.markup_type == 0 ? '$' : '%'), 1)
                              ]),
                              _createVNode("div", {
                                class: "dropdown-menu with-badge-list",
                                disabled: _ctx.state.ui.isLoading.isShow
                              }, [
                                _createVNode("ul", null, [
                                  _createVNode("li", null, [
                                    _createVNode("a", {
                                      class: "dropdown-item",
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.changeMarkupType(itemIndex, 0))
                                    }, "$ ", 8, ["onClick"]),
                                    (_ctx.state.defMarkUpType != 0)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 0,
                                          class: "badge badge-success",
                                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateMarkupType(0)))
                                        }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createVNode("li", null, [
                                    _createVNode("a", {
                                      class: "dropdown-item",
                                      href: "javascript:void(0)",
                                      onClick: ($event: any) => (_ctx.changeMarkupType(itemIndex, 1))
                                    }, "%", 8, ["onClick"]),
                                    (_ctx.state.defMarkUpType != 1)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 0,
                                          class: "badge badge-success",
                                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateMarkupType(1)))
                                        }, _toDisplayString(_ctx.$t('set_as_default')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 8, ["disabled"])
                            ]))
                      ])
                    ]),
                    _createVNode("td", null, _toDisplayString(item.total), 1),
                    (!_ctx.state.ui.isLoading.isShow)
                      ? (_openBlock(), _createBlock("td", _hoisted_86, [
                          (itemIndex == _ctx.state.data.subItems.length - 1)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: "javascript:void(0)",
                                class: "btn enable-btn mr-1",
                                onClick: ($event: any) => (_ctx.addMoreSubItems(item)),
                                disabled: _ctx.state.ui.isLoading.isShow
                              }, [
                                _hoisted_87,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                              ], 8, ["onClick", "disabled"]))
                            : _createCommentVNode("", true),
                          (_ctx.state.data.subItems.length != 1 && !_ctx.state.ui.isLoading.isEdit)
                            ? (_openBlock(), _createBlock("a", {
                                key: 1,
                                href: "javascript:void(0)",
                                class: "btn delete-btn",
                                onClick: ($event: any) => (_ctx.deleteSubItemShow(item)),
                                disabled: _ctx.state.ui.isLoading.isShow
                              }, [
                                _hoisted_88,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                              ], 8, ["onClick", "disabled"]))
                            : (_ctx.state.ui.isLoading.isEdit && _ctx.state.data.subItems.length > 0)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 2,
                                  href: "javascript:void(0)",
                                  class: "btn delete-btn",
                                  onClick: ($event: any) => (_ctx.deleteSubItemShow(item)),
                                  disabled: _ctx.state.ui.isLoading.isShow
                                }, [
                                  _hoisted_89,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                ], 8, ["onClick", "disabled"]))
                              : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.ui.isLoading.isEdit)
        ? (_openBlock(), _createBlock("div", _hoisted_90, [
            (!_ctx.state.ui.isLoading.isShow)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn default-btn d-inline-block",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateLineItem()))
                }, _toDisplayString(_ctx.$t('update')), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_91, [
            (!_ctx.state.ui.isLoading.isShow)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "btn default-btn d-inline-block",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.createLineItem())),
                  disabled: _ctx.state.ui.isLoading.isShow
                }, _toDisplayString(_ctx.$t('save')), 9, ["disabled"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_92, [
      _createVNode("div", _hoisted_93, [
        _createVNode("div", _hoisted_94, [
          _createVNode("div", _hoisted_95, [
            _createVNode("div", _hoisted_96, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_97, _toDisplayString(_ctx.$t('update_unit')), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_98, _toDisplayString(_ctx.$t('add_unit')), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_99
              ])
            ]),
            _createVNode("div", _hoisted_100, [
              _createVNode("div", _hoisted_101, [
                _createVNode("label", _hoisted_102, _toDisplayString(_ctx.$t('name')), 1),
                _withDirectives(_createVNode("input", {
                  class: _ctx.state.ui.errors.validationErrorList.unitName ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 2), [
                  [_vModelText, _ctx.state.data.unit.name]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitName)
                  ? (_openBlock(), _createBlock("p", _hoisted_103, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_104, [
                _hoisted_105,
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.unit.abbreviation = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.abbreviation]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitAbbreviation)
                  ? (_openBlock(), _createBlock("p", _hoisted_106, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitAbbreviation), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_107, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.updateUnit && _ctx.updateUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.createUnit && _ctx.createUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_108, [
      _createVNode("div", _hoisted_109, [
        _createVNode("div", _hoisted_110, [
          _createVNode("div", _hoisted_111, [
            _createVNode("div", _hoisted_112, [
              _createVNode("h5", _hoisted_113, _toDisplayString(_ctx.$t('remove_all_subitems')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.closeRemoveSubItem && _ctx.closeRemoveSubItem(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_114
              ])
            ]),
            _createVNode("div", _hoisted_115, [
              _createVNode("div", _hoisted_116, _toDisplayString(_ctx.$t('are_you_sure_you_want_to_remove')), 1)
            ]),
            _createVNode("div", _hoisted_117, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.removeAllSubItem && _ctx.removeAllSubItem(...args)))
              }, _toDisplayString(_ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.closeRemoveSubItem && _ctx.closeRemoveSubItem(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_118, [
      _createVNode("div", _hoisted_119, [
        _createVNode("div", _hoisted_120, [
          _createVNode("div", _hoisted_121, [
            _createVNode("div", _hoisted_122, [
              _createVNode("h5", _hoisted_123, _toDisplayString(_ctx.$t('delete_item')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.deleteItemClose()))
              }, [
                _hoisted_124
              ])
            ]),
            _createVNode("div", _hoisted_125, [
              _hoisted_126,
              _createVNode("span", _hoisted_127, _toDisplayString(_ctx.$t('are_you_sure')), 1)
            ]),
            _createVNode("div", _hoisted_128, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.deleteItemClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.deleteItemApi()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_129, [
      _createVNode("div", _hoisted_130, [
        _createVNode("div", _hoisted_131, [
          _createVNode("div", _hoisted_132, [
            _createVNode("div", _hoisted_133, [
              _createVNode("h5", _hoisted_134, _toDisplayString(_ctx.$t('delete_subitem')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.deleteSubItemClose()))
              }, [
                _hoisted_135
              ])
            ]),
            _createVNode("div", _hoisted_136, [
              _hoisted_137,
              _createVNode("span", _hoisted_138, _toDisplayString(_ctx.$t('are_you_sure')), 1)
            ]),
            _createVNode("div", _hoisted_139, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.deleteSubItemClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.deleteSubItemApi()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}